export const FULL_NAME_SAVE = 'FULL_NAME_SAVE';
